import React, { Component } from 'react';
import { func, string, bool } from 'prop-types';
import { connect } from 'react-redux';
import IsRequiredField from '../IsRequiredField';
import HelpButton from '../HelpButton';
import DateTimePicker from '../DateTimePicker';
import { API_DATE_FORMAT, surveyFieldIds } from '../../constants';
import { surveyOptionsType } from '../../constants/types';
import { updateSurveyOptionsAction } from '../../actions';
import WithValidation from '../WithValidation';
import { surveySchedulingValidator } from '../../validators/surveys';
import { withLang, langType } from '../../i18n';

import styles from './surveyScheduling.module.css';

class SurveyScheduling extends Component {
  constructor(props) {
    super(props);

    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.state = {};
  }

  componentDidMount() {
    const {
      surveyOptions, dispatchUpdate, showStartDate, initialStartDate
    } = this.props;

    if (showStartDate && (!surveyOptions || !surveyOptions.startDate)) {
      dispatchUpdate({ startDate: initialStartDate });
    }
  }

  onStartDateChange(startDate) {
    this.props.dispatchUpdate({ startDate });
  }

  onEndDateChange(endDate) {
    this.props.dispatchUpdate({ endDate });
  }

  render() {
    const {
      lang, showProblems, showStartDate, showEndDate,
      hasInvalidField, initialStartDate, initialEndDate,
      startLabelTextKey, startHelpTextKey, endLabelTextKey, endHelpTextKey, translate: t
    } = this.props;

    const startSurveyClasses = showProblems && hasInvalidField(surveyFieldIds.START_DATE)
      ? `${styles.formItem} ${surveyFieldIds.START_DATE}_container formError`
      : `${styles.formItem} ${surveyFieldIds.START_DATE}_container`;
    const endSurveyClasses = showProblems && hasInvalidField(surveyFieldIds.END_DATE)
      ? `${styles.formItem} ${surveyFieldIds.END_DATE}_container formError`
      : `${styles.formItem} ${surveyFieldIds.END_DATE}_container`;

    return (
      <div>
        {showStartDate
      && (
      <div id="startDate" className={startSurveyClasses}>
        <label htmlFor={surveyFieldIds.START_DATE}>
          {t(startLabelTextKey)}
          <IsRequiredField />
          <HelpButton content={t(startHelpTextKey)} />
        </label>
        <DateTimePicker
          locale={lang}
          dateOutputFormat={API_DATE_FORMAT}
          defaultValue={initialStartDate}
          onChange={this.onStartDateChange}
          fieldName={surveyFieldIds.START_DATE}
        />
      </div>
      )}
        {showEndDate
        && (
        <div id="endDate" className={endSurveyClasses}>
          <label htmlFor={surveyFieldIds.END_DATE}>
            {t(endLabelTextKey)}
            <IsRequiredField />
            <HelpButton content={t(endHelpTextKey)} />
          </label>
          <DateTimePicker
            locale={lang}
            dateOutputFormat={API_DATE_FORMAT}
            defaultValue={initialEndDate}
            onChange={this.onEndDateChange}
            fieldName={surveyFieldIds.END_DATE}
          />
        </div>
        )}
      </div>
    );
  }
}

SurveyScheduling.propTypes = {
  surveyOptions: surveyOptionsType.isRequired,
  dispatchUpdate: func.isRequired,
  showProblems: bool.isRequired,
  hasInvalidField: func.isRequired,
  showStartDate: bool,
  showEndDate: bool,
  initialStartDate: string,
  initialEndDate: string,
  startLabelTextKey: string,
  startHelpTextKey: string,
  endLabelTextKey: string,
  endHelpTextKey: string,
  ...langType
};

SurveyScheduling.defaultProps = {
  showStartDate: true,
  showEndDate: true,
  initialStartDate: '',
  initialEndDate: '',
  startLabelTextKey: 'startSurvey.startDate',
  startHelpTextKey: 'startSurvey.startDateHelp',
  endLabelTextKey: 'startSurvey.endDate',
  endHelpTextKey: 'startSurvey.endDateHelp'
};

const mapStateToProps = ({ survey }) => ({
  surveyOptions: survey.surveyOptions
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdate: (surveyOptions) =>
    dispatch(updateSurveyOptionsAction(surveyOptions))
});

export default withLang(connect(mapStateToProps,
  mapDispatchToProps)(WithValidation(SurveyScheduling, surveySchedulingValidator)));
